import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const usePlaylist = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPlaylist = async () => {
    try {
      const response = await fetch(`${BASE_URL}/student/playlist/all/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      const data = await response.json();

      if (response.ok) {
        setCourses(data);
      } else {
        setCourses([]);
      }
    } catch (error) {
      console.error("Error fetching playlist:", error);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlaylist();
  }, []);

  return { courses, loading, fetchPlaylist };
};

export default usePlaylist;
